import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';

const RedirectToTariffScreen = withRouter(({ location }: RouteComponentProps) =>
  <Redirect to={{ pathname: '/tariff', search: `?redirect=${location.pathname}` }} />
);

export default RedirectToTariffScreen;
